// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-node_modules_ng-select_ng-select_fesm2020_ng-select-ng-select_mjs-src_assets_iso_json":"dd83630d2cca76b0","src_app_hub_hub_module_ts":"10defa35b3f66bb4","src_app_pages_pages_module_ts":"f32292c9714eaf69","src_app_pages_admin_admin_module_ts":"52b4f8315793a94e"}[chunkId] + ".js";
};